import { useNavigate } from "react-router-dom";
import AvatarChoiceScreen from "../../compoment/AvatarChoiceScreen";
import { RESTORE_SELECTION } from "../../utils/backNavigation";

const ChooseFriendAvatarScreen = () => {
    const navigate = useNavigate();

    return (
        <AvatarChoiceScreen
            title={
                <>
                    CHOOSE YOUR
                    <br />
                    FRIEND’S AVATAR
                </>
            }
            groupLabel="Choose your friend’s avatar"
            storageKey="friendGender"
            onBack={() => navigate("/choose-avatar", RESTORE_SELECTION)}
            isFinalStep
        />
    );
};

export default ChooseFriendAvatarScreen;
